import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import Swal from "sweetalert2";
import { AngularFireStorage } from "@angular/fire/storage";

import {
  User,
  Comment,
  Discussion,
  DiscussionService,
  PanelMember,
} from "../../../../shared";

@Component({
  selector: "discussion-content-section",
  templateUrl: "./discussion-content-section.component.html",
  styleUrls: [
    "./discussion-content-section.component.scss",
    "../../../../../assets/icon/icofont/css/icofont.scss",
    "../../../../../../node_modules/sweetalert2/src/sweetalert2.scss",
  ],
})
export class DiscussionContentSectionComponent implements OnInit {
  public isDeleting: boolean;
  @Input() currentUser: User;
  @Input() discussion: Discussion;
  @Input() canModifyDiscussion: boolean;
  @Input() currentPanelMember: PanelMember;
  @Input() comments: Comment[];

  constructor(
    private discussionService: DiscussionService,
    private afStorage: AngularFireStorage,
    private router: Router
  ) {}

  ngOnInit() {}

  public deleteDiscussion() {
    this.isDeleting = true;
    this.discussionService.deleteOne(this.discussion).subscribe((success) => {
      this.isDeleting = false;
      this.deleteFirebaseImg();
      this.router.navigateByUrl("/");
    });
  }

  public deleteFirebaseImg() {
    if (this.discussion.image) {
      if (this.discussion.image.indexOf("firebasestorage") > -1) {
        this.afStorage.storage.refFromURL(this.discussion.image).delete();
      }
    }
  }

  public onToggleUpvote(upvoted: boolean) {
    this.discussion.voted.upVote = upvoted;

    if (this.discussion.voted.downVote && this.discussion.voted.upVote) {
      this.onToggleDownvote(false);
    }

    if (upvoted) {
      this.discussion.upVoteCount++;
    } else {
      this.discussion.upVoteCount--;
    }
  }

  public onToggleDownvote(downvoted: boolean) {
    this.discussion.voted.downVote = downvoted;

    if (this.discussion.voted.downVote && this.discussion.voted.upVote) {
      this.onToggleUpvote(false);
    }

    if (downvoted) {
      this.discussion.downVoteCount++;
    } else {
      this.discussion.downVoteCount--;
    }
  }

  public onToggleBookmark(bookmarked: boolean) {
    this.discussion.bookmarked = bookmarked;

    if (bookmarked === true) {
      this.discussion.bookmarkCount++;
    } else if (bookmarked === false) {
      this.discussion.bookmarkCount--;
    }
  }

  public openDiscussionDeleteConfirmation() {
    Swal.fire({
      title: "Are you sure you want to delete this Discussion?",
      text: "You wont be able to revert",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete the Discussion!",
    }).then((result) => {
      if (result.value) {
        Swal.fire("Deleted!", "Your Discussion has been deleted.", "success");
        this.deleteDiscussion();
      }
    });
  }
}
